<!-- Qué graficar (chips) y el rango de tiempo -->
<div class="controles">
  <div class="series" role="group" aria-label="Mediciones a graficar">
    @for (key of claves; track key) {
      <button
        type="button"
        class="irx-chip"
        [attr.aria-pressed]="seleccionada(key)"
        (click)="toggleKeySelection(key)"
      >
        {{ nombreSerie(key) }}
      </button>
    }
  </div>

  <ng-select
    class="rango"
    [items]="opcionesFechas"
    bindLabel="label"
    bindValue="value"
    [(ngModel)]="horasSeleccionadas"
    (change)="cambiarRangoFechas()"
    placeholder="Rango de tiempo"
    [clearable]="false"
  ></ng-select>
</div>

<!-- Un panel por medición, con el gráfico sobre el fondo del panel -->
@if (chartOptionsList.length > 0) {
  <div class="graficos">
    @for (options of chartOptionsList; track options; let i = $index) {
      <div class="grafico">
        <div class="grafico-cabecera">
          <span class="grafico-titulo">
            {{ $any(options).customOptions?.title }}
          </span>
          <button
            irxBotonIcono
            tamano="compacto"
            tooltip="Expandir gráfico"
            (click)="abrirGrafico(chartKeys[i])"
          >
            <mat-icon>open_in_full</mat-icon>
          </button>
        </div>
        <highcharts-chart
          class="lienzo"
          [Highcharts]="Highcharts"
          [options]="options"
          (chartInstance)="onChartInstance(i, $event)"
        ></highcharts-chart>
      </div>
    }
  </div>
} @else {
  <p class="vacio">Elegí al menos una medición para graficar.</p>
}
